// Shared constants for the shop.getdub.com marketing landing page.
// Assets, copy, and links are mirrored from the live Shopify storefront at
// getdub.com so this React replica stays visually and textually faithful.

// Shopify CDN base for the getdub store (shop id 1/0961/4275/3865).
const CDN = 'https://cdn.shopify.com/s/files/1/0961/4275/3865/files'

export const ASSETS = {
  logo: `${CDN}/dub-logo.svg?v=1769271997`,
  logoWhite: `${CDN}/dub-logo-white.svg?v=1769294401`,
  heroPhone: `${CDN}/hand-app-4_2x_64eb714c-f1d6-4c4d-a28a-494de288000b.png?v=1772304197`,
  family: `${CDN}/dub-family_2x_87de8592-1038-436d-8427-e82b3808303a.png?v=1770402796`,
  bracket: `${CDN}/bracket-ornge.png?v=1773613134`,
  phoneSports: `${CDN}/phone-sports-3_2x_4862a764-3ead-4831-8dc5-b34c3ce09104.png?v=1772690269`,
  group: `${CDN}/group-5.png?v=1775539896`,
  testimonial1: `${CDN}/Testimonial-image.png`,
  testimonial2: `${CDN}/Testimonial-image-2.png?v=1769723962`,
  // Section background art
  bgHowToPlay: `${CDN}/bg-how-to-play_2x_4d2e9fc0-62e1-4069-bbb7-43deda11cd88.png?v=1769293695&width=2000`,
  bgFootball: `${CDN}/bg-football.png?v=1770842256&width=2000`,
  bgCta: `${CDN}/bg-cta_2x_aa7703f9-cfb4-4792-a0f2-d524d925d337.png?v=1769711601&width=2000`,
  bgFooter: `${CDN}/bg-footer_2x_f1a2784d-cbc0-4e1d-a054-5fdcab21b59d.png?v=1769293695&width=2200`,
}

import { appLink, homeLink, storeLink } from '@/lib/siteLinks'

// Destinations. In production the app lives on app.getdub.com and the store
// only at getdub.com/merch (appLink/storeLink resolve the host — see
// lib/siteLinks.js). Legal pages live at /terms and /privacy.
export const LINKS = {
  home: homeLink(),
  app: appLink('/login'),
  register: appLink('/register'),
  store: storeLink(),
  cart: storeLink(),
  collectionAll: storeLink(),
  collectionMens: storeLink(),
  collectionWomens: storeLink(),
  terms: '/terms',
  privacy: '/privacy',
  contact: '/contact',
  instagram: 'https://www.instagram.com/getyourdub/',
  partner: 'https://www.instagram.com/lamaddrops/',
  product: (handle) => storeLink(`/merch/products/${handle}`),
}

export const STEPS = [
  {
    n: 1,
    title: 'Make your picks',
    body: 'Choose a tournament. Make your picks before play begins.',
  },
  {
    n: 2,
    title: 'Follow the action',
    body: 'Watch the real-world event while rooting for your picks to win.',
  },
  {
    n: 3,
    title: 'Compete with friends',
    body: 'Create or join friendly groups and earn points to climb the leaderboard.',
  },
  {
    n: 4,
    title: 'Win cool prizes',
    body: 'Top dubs get free merch!',
  },
]

export const TESTIMONIALS = [
  {
    quote: 'It’s so fun to have the thrill of March Madness brought to pro pickleball!',
    name: 'Pickleball player',
    location: 'Florida',
    image: ASSETS.testimonial2,
  },
  {
    quote:
      'Finishing above my son on the leaderboard was awesome! He couldn’t believe I correctly picked so many upsets.',
    name: 'Parent of a competitive child',
    location: 'Texas',
    image: ASSETS.testimonial1,
  },
]

// The homepage merch strip loads its featured products live from the
// Storefront API (see ShopMerch.jsx) so it always matches the store.
